/* eslint-disable no-undef */
import React from 'react';
import { Styles } from './styles';
import { Button, Box } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import {
  IAuthenticatedPropertyDetails,
  IPropertyDetails
} from '@stores/Property/types';
import { useWhatsAppStore } from '@stores/WhatsApp/WhatsApp';

interface DescriptionContainerProps {
  title: string;
  description: string;
  showWhatsappButton?: boolean;
  property?: IPropertyDetails | IAuthenticatedPropertyDetails | null;
}

const DescriptionContainer: React.FC<DescriptionContainerProps> = ({
  title,
  description,
  showWhatsappButton = false,
  property
}) => {
  const { openWhatsApp } = useWhatsAppStore();

  const handleWhatsAppClick = () => {
    if (!property) return;

    const cod =
      typeof property.cod_imovel === 'string'
        ? property.cod_imovel
        : (property.cod_imovel?.cod ?? String(property.id));

    const operacao = property.is_venda ? 'Venda' : 'Aluguel';
    const valor = property.is_venda
      ? property.valor_venda
      : property.valor_aluguel;

    openWhatsApp({
      phone: property.corretor.cellphone,
      propertyId: property.id,
      propertyCode: cod,
      titulo: property.titulo,
      valor,
      operacao
    });
  };

  return (
    <Styles.DescriptionContainer>
      {/* <Styles.Title>{title}</Styles.Title> */}
      <Styles.Description
        dangerouslySetInnerHTML={{ __html: description || '' }}
      />
      {showWhatsappButton && property && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button
            variant="contained"
            startIcon={<WhatsAppIcon />}
            onClick={handleWhatsAppClick}
            sx={{
              backgroundColor: '#25D366',
              color: '#fff',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: '8px',
              paddingX: 3,
              '&:hover': {
                backgroundColor: '#1ebe5d'
              }
            }}>
            Entre em contato
          </Button>
        </Box>
      )}
      {/* <Styles.SingleText>Agende uma visita conosco!</Styles.SingleText> */}
    </Styles.DescriptionContainer>
  );
};

export default DescriptionContainer;
